__turbopack_context__.v({
  "Description": "ThankYouModal-module-scss-module__oXYJFW__Description",
  "Image": "ThankYouModal-module-scss-module__oXYJFW__Image",
  "ImageContainer": "ThankYouModal-module-scss-module__oXYJFW__ImageContainer",
  "Title": "ThankYouModal-module-scss-module__oXYJFW__Title",
});
